import * as Sentry from '@sentry/browser'

/**
 * Captures submit error
 * @param {Error} error
 * @param {boolean} rethrow
 */
export function captureSubmitError(error, rethrow = true) {
  const { href, origin, pathname, search } = window.location
  const event = 'form-error'
  const name = `${event}@${origin}${pathname}`

  Sentry.captureException(error, (scope) => {
    // scope.clear()
    scope.setTransactionName(name)

    scope.setTags({
      metric: event,
    })

    scope.setExtras({
      href,
      pathname,
      origin,
      search,
    })

    return scope
  })

  console.error(error)

  if (rethrow) {
    throw error
  }
}
